import { useCallback } from "react";
import { useIntl } from "react-intl";
import type { Country } from "src/shared/objects/Country";

export const useGetCountryNames = () => {
  const { locale } = useIntl();
  return useCallback(
    (country: Country) =>
      country[`countryName${locale.toUpperCase()}`] ?? locale,
    [locale],
  );
};
